/*!
=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/*eslint-disable*/
import React, { Component } from "react";
import { Collapse } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.jsx";

// image for avatar in Sidebar
//import avatar from "assets/img/user-img.png";
import logo from "assets/img/logo-white.png";
// logo for sidebar
//import logo from "logo.svg";

import routes from "routes.js";
import { Logout } from "../../Listfunction";
import { deleteFirebaseToken } from "notifications/firebase";
import { setCustomUserID } from "utils/Clarity";
import InventoryList from "views/Forms/Inventory/viewInventoryList";

var ps;

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.getCollapseStates(routes),
      openAvatar: false,
      isWindows: navigator.platform.indexOf("Win") > -1 ? true : false,
      width: window.innerWidth,
      username: "",
      userrole: "",
      storeName: "",
    };
    this.logout = this.logout.bind(this);
  }

  async logout() {
    localStorage.removeItem("user");
    //localStorage.setItem('user', "");
    await deleteFirebaseToken();
    this.props.history.push("/auth/login-page");
    // Logout()
    // .then(()=>{
    //   alert('logout');
    //   // window.location.reload();
    //     // window.location.href = "#/auth/login-page";
    // })
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }

      if (this.state.userrole == 6) {
        if (prop.collapse) {
          var st = {};
          st[prop["state"]] = !this.state[prop.state];
          if (
            (prop.path == "/order " && prop.name == "Orders") ||
            (prop.path == "/order " && prop.name == "Lab")
          ) {
            return (
              <li
                className={
                  this.getCollapseInitialState(prop.views) ? "active" : ""
                }
                key={key}
              >
                <a
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState(st);
                  }}
                >
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b
                      className={
                        this.state[prop.state]
                          ? "caret rotate-180"
                          : "caret caret-down"
                      }
                    />
                  </p>
                </a>
                <Collapse in={this.state[prop.state]}>
                  <ul className="nav">{this.createLinks(prop.views)}</ul>
                </Collapse>
              </li>
            );
          }
        }

        if (prop.path == "/lab_order_list" || prop.path == "/lab-add-order") {
          if (1) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else {
        }
      } else if (this.state.userrole === 16) {
        if (prop.collapse) {
          var st = {};
          st[prop["state"]] = !this.state[prop.state];
          if (
            (prop.path === "/management" && prop.name === "Management") ||
            (prop.path === "/Claims" && prop.name === "Claims")
          ) {
            return (
              <li
                className={
                  this.getCollapseInitialState(prop.views) ? "active" : ""
                }
                key={key}
              >
                <a
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState(st);
                  }}
                >
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b
                      className={
                        this.state[prop.state]
                          ? "caret rotate-180"
                          : "caret caret-down"
                      }
                    />
                  </p>
                </a>
                <Collapse in={this.state[prop.state]}>
                  <ul className="nav">{this.createLinks(prop.views)}</ul>
                </Collapse>
              </li>
            );
          }
        }

        if (
          prop.path === "/claim" ||
          prop.path === "/userManagement" ||
          prop.path === "/logs" ||
          prop.path === "/contact" ||
          prop.path === "/transaction"
        ) {
          if (prop.isDisplay === "yes") {
            return (
              <li
                className={this.activeRoute(prop.layout + prop.path)}
                key={key}
              >
                <NavLink
                  to={prop.layout + prop.path}
                  className="nav-link"
                  activeClassName="active"
                >
                  {prop.icon ? (
                    <>
                      <i className={prop.icon} />
                      <p>{prop.name}</p>
                    </>
                  ) : (
                    <>
                      <span className="sidebar-mini">{prop.mini}</span>
                      <span className="sidebar-normal">{prop.name}</span>
                    </>
                  )}
                </NavLink>
              </li>
            );
          }
        }
      } else if (this.state.userrole == 17) {
        if (prop.collapse) {
          if (prop.path === "/Warehouse" && prop.name === "Inventory Request") {
            let filteredViews = (prop.views || []).filter(
              (view) =>
                view.path === "/purchase-request" ||
                view.path === "/authorization-level" ||
                view.path === "/poList" ||
                view.path === "/medication",
            );

            if (!filteredViews.some((v) => v.path === "/poList")) {
              let poListRoute = null;
              if (prop.views) {
                poListRoute = prop.views.find((v) => v.path === "/poList");
              }
              if (!poListRoute) {
                poListRoute = {
                  path: "/poList",
                  layout: "/admin",
                  name: "Purchase Order",
                  icon: "fa fa-sliders",
                  component: undefined,
                  isDisplay: "no",
                };
              }
              filteredViews.push(poListRoute);
            }

            return filteredViews.map((view) => (
              <li
                className={this.activeRoute(view.layout + view.path)}
                key={view.path}
              >
                <NavLink
                  to={view.layout + view.path}
                  className="nav-link"
                  activeClassName="active"
                >
                  <i className={view.icon} />
                  <p>{view.name}</p>
                </NavLink>
              </li>
            ));
          }

          if (prop.path === "/management" && prop.name === "Management") {
            const inventoryGroup = (prop.views || []).find(
              (view) =>
                view.collapse &&
                view.path === "/inventory" &&
                view.name === "Inventory",
            );

            const filteredViews = (
              (inventoryGroup && inventoryGroup.views) ||
              []
            ).filter((view) => view.path === "/inventoryList");

            if (!filteredViews.length) {
              return null;
            }

            return filteredViews.map((view) => (
              <li
                className={this.activeRoute(view.layout + view.path)}
                key={view.path}
              >
                <NavLink
                  to={view.layout + view.path}
                  className="nav-link"
                  activeClassName="active"
                >
                  <i className={view.icon} />
                  <p>{view.name}</p>
                </NavLink>
              </li>
            ));
          }
          return null;
        }

        if (
          (prop.path === "/purchase-request" ||
            prop.path === "/inventoryList" ||
            prop.path === "/medication") &&
          // ||
          // prop.path === "/storeRequest"
          prop.isDisplay === "yes"
        ) {
          return (
            <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
              <NavLink
                to={prop.layout + prop.path}
                className="nav-link"
                activeClassName="active"
              >
                {prop.icon ? (
                  <>
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </>
                ) : (
                  <>
                    <span className="sidebar-mini">{prop.mini}</span>
                    <span className="sidebar-normal">{prop.name}</span>
                  </>
                )}
              </NavLink>
            </li>
          );
        }

        return null;
      } else if (this.state.userrole == 18) {
        if (prop.collapse) {
          if (
            (prop.path === "/Warehouse" && prop.name === "Inventory Request") ||
            (prop.path === "/order" && prop.name === "Orders") ||
            (prop.path === "/inventory" && prop.name === "Inventory")
          ) {
            let filteredViews = prop.views.filter(
              (view) =>
                view.path === "/purchase-request" ||
                view.path === "/getRelatedStore" ||
                view.path === "/order_list" ||
                view.path === "/poList" ||
                view.path === "/Good-Return-Note-Bulk-Upload",
            );
            return filteredViews.map((view) => (
              <li
                className={this.activeRoute(view.layout + view.path)}
                key={view.path}
              >
                <NavLink
                  to={view.layout + view.path}
                  className="nav-link"
                  activeClassName="active"
                >
                  <i className={view.icon} />
                  <p>
                    {this.state.userrole === 18 && view.path === "/poList"
                      ? "Outside Purchase"
                      : view.name}
                  </p>
                </NavLink>
              </li>
            ));
          }
        }
      } else if (this.state.userrole == 12) {
        if (prop.collapse) {
          var st = {};
          st[prop["state"]] = !this.state[prop.state];
          /* if (
            prop.path == "/management" ||
            prop.path == "/couponcodemanagement"
          )
            return (
              <li
                className={
                  this.getCollapseInitialState(prop.views) ? "active" : ""
                }
                key={key}
              >
                <a
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState(st);
                  }}
                >
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b
                      className={
                        this.state[prop.state]
                          ? "caret rotate-180"
                          : "caret caret-down"
                      }
                    />
                  </p>
                </a>
                <Collapse in={this.state[prop.state]}>
                  <ul className="nav">{this.createLinks(prop.views)}</ul>
                </Collapse>
              </li>
            ); */
        }
        if (prop.path == "/useCoupon") {
          if (1) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        }
      } else if (this.state.userrole == 13) {
        const role13AllowedPaths = [];
        const role13BlockedInventoryPaths = [
          "/inventoryList",
          "/expiryMedication",
          "/medication-category",
          "/medicationTags",
          "/reportlist",
          "/packagelist",
        ];
        const role13PriorityInventoryViews = [
          {
            path: "/purchase-request",
            layout: "/admin",
            name: "Stock Refill Requests",
            mini: "CLM",
            icon: "fa fa-refresh",
            isDisplay: "yes",
          },
        ];

        if (prop.collapse) {
          const collapseAllowedViews = {
            "/management": ["/inventory"],
          };

          let filteredViews = [];
          if (prop.path === "/inventory") {
            filteredViews = (prop.views || []).filter(
              (view) =>
                (view.collapse || view.isDisplay == "yes") &&
                !role13BlockedInventoryPaths.includes(view.path),
            );

            if (!filteredViews.length) {
              return null;
            }

            const taggedViews = [
              ...role13PriorityInventoryViews,
              ...filteredViews,
            ].map((view) => ({
              ...view,
              _role13InventoryItem: true,
            }));

            return this.createLinks(taggedViews);
          }
          const allowedChildPaths = collapseAllowedViews[prop.path];

          if (!allowedChildPaths) {
            return null;
          }

          filteredViews = (prop.views || []).filter(
            (view) =>
              allowedChildPaths.includes(view.path) &&
              (view.collapse || view.isDisplay == "yes"),
          );

          if (!filteredViews.length) {
            return null;
          }

          if (prop.path === "/management" || prop.path === "/Warehouse") {
            return this.createLinks(filteredViews);
          }

          return null;
        }

        if (
          (prop._role13InventoryItem ||
            role13AllowedPaths.includes(prop.path)) &&
          prop.isDisplay == "yes"
        ) {
          return (
            <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
              <NavLink
                to={prop.layout + prop.path}
                className="nav-link"
                activeClassName="active"
              >
                {prop.icon ? (
                  <>
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </>
                ) : (
                  <>
                    <span className="sidebar-mini">{prop.mini}</span>
                    <span className="sidebar-normal">{prop.name}</span>
                  </>
                )}
              </NavLink>
            </li>
          );
        }

        return null;
      } else if (this.state.userrole == 11) {
        const role11AllowedPaths = [
          "/order_list",
          "/medication",
          "/inventoryList",
          "/poList",
          "/purchase-request",
          "/claim",
          "/tickets",
          "/addticket",
        ];

        if (prop.collapse) {
          const collapseAllowedViews = {
            "/order": ["/order_list"],
            "/management": ["/inventory", "/Claims"],
            "/inventory": ["/medication", "/inventoryList", "/poList"],
            "/Warehouse": ["/purchase-request"],
            "/Claims": ["/claim"],
            "/helpdesk": ["/tickets", "/addticket"],
          };

          const allowedChildPaths = collapseAllowedViews[prop.path];
          if (!allowedChildPaths) {
            return null;
          }

          const filteredViews = (prop.views || []).filter(
            (view) =>
              allowedChildPaths.includes(view.path) &&
              (view.collapse || view.isDisplay == "yes"),
          );

          if (!filteredViews.length) {
            return null;
          }

          if (
            prop.path === "/management" ||
            prop.path === "/order" ||
            prop.path === "/Warehouse"
          ) {
            return this.createLinks(filteredViews);
          }

          var st = {};
          st[prop["state"]] = !this.state[prop.state];

          return (
            <li
              className={
                this.getCollapseInitialState(filteredViews) ? "active" : ""
              }
              key={key}
            >
              <a
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState(st);
                }}
              >
                <i className={prop.icon} />
                <p>
                  {prop.name}
                  <b
                    className={
                      this.state[prop.state]
                        ? "caret rotate-180"
                        : "caret caret-down"
                    }
                  />
                </p>
              </a>
              <Collapse in={this.state[prop.state]}>
                <ul className="nav">{this.createLinks(filteredViews)}</ul>
              </Collapse>
            </li>
          );
        }

        if (role11AllowedPaths.includes(prop.path) && prop.isDisplay == "yes") {
          return (
            <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
              <NavLink
                to={prop.layout + prop.path}
                className="nav-link"
                activeClassName="active"
              >
                {prop.icon ? (
                  <>
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </>
                ) : (
                  <>
                    <span className="sidebar-mini">{prop.mini}</span>
                    <span className="sidebar-normal">{prop.name}</span>
                  </>
                )}
              </NavLink>
            </li>
          );
        }

        return null;
      } else {
        if (prop.collapse) {
          var st = {};
          st[prop["state"]] = !this.state[prop.state];

          return (
            <li
              className={
                this.getCollapseInitialState(prop.views) ? "active" : ""
              }
              key={key}
            >
              <a
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState(st);
                }}
              >
                <i className={prop.icon} />
                <p>
                  {prop.name}
                  <b
                    className={
                      this.state[prop.state]
                        ? "caret rotate-180"
                        : "caret caret-down"
                    }
                  />
                </p>
              </a>
              <Collapse in={this.state[prop.state]}>
                <ul className="nav">{this.createLinks(prop.views)}</ul>
              </Collapse>
            </li>
          );
        }

        if (prop.path == "/user_log") {
          if (this.state.userrole == 1 || this.state.userrole == 2) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (
          prop.path == "/Bulkimport" ||
          prop.path == "/order-import" ||
          prop.path == "/lab-order-import" ||
          prop.path == "/customer-import" ||
          prop.path == "/useCoupon"
        ) {
          if (this.state.userrole == 1 || this.state.userrole == 2) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (prop.path == "/rider") {
          if (this.state.userrole == 1 || this.state.userrole == 2) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (prop.path == "/addcredit" || prop.path === "/reports") {
          if (this.state.userrole == 1) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (prop.path == "/activitydetails") {
          if (this.state.userrole == 1 || this.state.userrole == 2) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (prop.path == "/user") {
          if (
            this.state.userrole == 1 ||
            this.state.userrole == 2 ||
            this.state.userrole == 13
          ) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (prop.path == "/setting") {
          if (this.state.userrole == 1) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (prop.path == "/inventoryList") {
          if (
            this.state.userrole == 1 ||
            this.state.userrole == 11 ||
            this.state.userrole == 17
          ) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (
          prop.path == "/setting" ||
          prop.path == "/rider" ||
          prop.path == "/subscription" ||
          prop.path == "/medication" ||
          prop.path == "/healthcondition" ||
          prop.path == "/medication-category" ||
          prop.path == "/viewb2b" ||
          prop.path == "/order_list" ||
          prop.path == "/activitydetails" ||
          prop.path == "/addb2b" ||
          prop.path == "/add-order"
        ) {
          if (
            this.state.userrole == 1 ||
            this.state.userrole == 2 ||
            this.state.userrole == 3 ||
            this.state.userrole == 4 ||
            this.state.userrole == 5 ||
            this.state.userrole == 11 ||
            this.state.userrole == 17
          ) {
            if (prop.isDisplay == "yes") {
              return (
                <li
                  className={this.activeRoute(prop.layout + prop.path)}
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    {prop.icon ? (
                      <>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>
                    ) : (
                      <>
                        <span className="sidebar-mini">{prop.mini}</span>
                        <span className="sidebar-normal">{prop.name}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              );
            }
          }
        } else if (prop.role === 16) {
          return null;
        } else {
          if (prop.isDisplay == "yes") {
            return (
              <li
                className={this.activeRoute(prop.layout + prop.path)}
                key={key}
              >
                <NavLink
                  to={prop.layout + prop.path}
                  className="nav-link"
                  activeClassName="active"
                >
                  {prop.icon ? (
                    <>
                      <i className={prop.icon} />
                      <p>{prop.name}</p>
                    </>
                  ) : (
                    <>
                      <span className="sidebar-mini">{prop.mini}</span>
                      <span className="sidebar-normal">{prop.name}</span>
                    </>
                  )}
                </NavLink>
              </li>
            );
          }
        }
      }
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = (routeName) => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // if the windows width changes CSS has to make some changes
  // this functions tell react what width is the window
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidUpdate() {
    if (navigator.platform.indexOf("Win") > -1) {
      setTimeout(() => {
        ps.update();
      }, 350);
    }
  }
  componentDidMount() {
    if (
      localStorage.getItem("user") == null ||
      localStorage.getItem("user") == ""
    ) {
      window.location.href = "/auth/login-page";
    } else {
      var token = JSON.parse(localStorage.getItem("user"));
      const username = token.name;
      this.setState({
        username: username,
        userrole: token.role,
        storeName: token.store_name,
      });
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions.bind(this));
      if (navigator.platform.indexOf("Win") > -1) {
        ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
      }
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    // const user_role_arr = {
    //   1: "SuperAdmin",
    //   2: "Admin",
    //   3: "User",
    //   4: "Third Party",
    //   5: "Rider",
    //   6: "Lab Partner",
    //   7: "Lab Rider",
    //   8: "Supplier",
    //   9: "Doctor",
    //   10: "Courier Partner",
    //   11: "Pharmacist",
    //   12: "Partner",
    //   13: "Procurement",
    //   14: "Insurance",
    //   15: "Insurance Ref",
    //   16: "Reviewer",
    //   17: "Store Manager",
    //   18: "Store Phamasist",
    // };

    return (
      <div
        // style={{ width: "276px" }}
        className="sidebar"
        data-color="custom-red"
        data-image={this.props.image}
      >
        {this.props.hasImage ? (
          <div
            className="sidebar-background"
            style={{ backgroundColor: "#ffffff" }}
          />
        ) : (
          ""
        )}
        <div
          className="logo"
          style={{
            textAlign: "left",
            padding: "4.3px",
            backgroundColor: "#ffffff",
          }}
        >
          <a
            href={"/admin/dashboard"}
            className="simple-text logo-normal"
            target="_blank"
            style={{ marginLeft: "4px" }}
          >
            <img
              src="https://flash-prod.s3.ap-south-1.amazonaws.com/adminNewImage/logo.png"
              alt="react-logo"
              style={{ width: "54px", margin: "7px" }}
              // width="150"
              // style={{ margin: "7px" }}
            />
            <span
              className="logotextnew"
              style={{
                fontFamily: "inherit",
                fontWeight: "600",
              }}
            >
              Flash Health
            </span>
          </a>
        </div>
        <div
          className="sidebar-wrapper"
          ref="sidebarWrapper"
          // style={{ width: "275px" }}
        >
          <div
            className="user"
            style={{
              textAlign: "center",
              padding: "20px 0px",
              margin: "10px 15px",
              backgroundColor: "#f1f4f6",
              borderRadius: "10px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
          >
            {/* <div className="photo">
              <img src={avatar} alt="Avatar" />
            </div> */}
            <div className="info" style={{ fontSize: "17px" }}>
              <a
                href="#pablo"
                style={{ lineHeight: "60px" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ openAvatar: !this.state.openAvatar });
                }}
              >
                {/* <img
                  src="https://flash-prod.s3.ap-south-1.amazonaws.com/adminNewImage/avatar_icon.png"
                  alt="avatar"
                  style={{
                    width: 60,
                    // height: 40,
                    // borderRadius: "50%",
                    // marginRight: 10,
                  }}
                /> */}
                <span
                  className="logotextnew"
                  style={{
                    fontFamily: "inherit",
                    fontWeight: "600",
                  }}
                >
                  {this.state.username}
                  {/* <b
                    className={
                      this.state.openAvatar
                        ? "caret rotate-180"
                        : "caret caret-down-admin"
                    }
                  /> */}
                </span>
                {/* {this.state.userrole != 18 ? (
                  <span
                    className="logotextnew"
                    style={{
                      fontfamily: "inherit",
                      fontWeight: "600",
                    }}
                  >
                    {user_role_arr[this.state.userrole]}
                    <b />
                  </span>
                ) : (
                  ""
                )} */}
                {this.state.userrole == 18 ? (
                  <span
                    className="logotextnew"
                    style={{
                      fontfamily: "inherit",
                      fontWeight: "600",
                    }}
                  >
                    {this.state.storeName}&nbsp;Store
                    <b
                    // className={
                    //   this.state.openAvatar
                    //     ? "caret rotate-180"
                    //     : "caret caret-down-admin"
                    // }
                    />
                  </span>
                ) : (
                  ""
                )}
              </a>
              <Collapse in={this.state.openAvatar}>
                <ul className="nav">
                  {/* <li>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <span className="sidebar-mini">MP</span>
                      <span className="sidebar-normal">My Profile</span>
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <span className="sidebar-mini">EP</span>
                      <span className="sidebar-normal">Edit Profile</span>
                    </a>
                  </li> */}
                  {/* <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <span className="sidebar-normal">
                        <a
                          className="logoutBtn"
                          onClick={this.logout.bind(this)}
                          align="center"
                          style={{ fontSize: "15px" }}
                        >
                          {" "}
                          Logout
                        </a>
                      </span>
                    </a>
                  </li> */}
                </ul>
              </Collapse>
            </div>
          </div>
          <ul className="nav">
            {/*
              If we are on responsive, we want both links from navbar and sidebar
              to appear in sidebar, so we render here HeaderLinks
            */}
            {this.state.width <= 992 ? <AdminNavbarLinks /> : null}
            {/*
              here we render the links in the sidebar if the link is simple,
              we make a simple link, if not, we have to create a collapsible group,
              with the speciffic parent button and with it's children which are the links
            */}
            {this.createLinks(routes)}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;
